var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":"MonitorView,ScreenControlView"}},[_c('router-view')],1),(_vm.$route.path === '/mine'  || _vm.$route.path === '/screenControl'|| _vm.$route.path === '/monitor' || _vm.$route.path === '/inspection' )?_c('BottomNav'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }